import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, ArrowLeft } from 'lucide-react';

const Header = ({ 
  userName, 
  onLogout, 
  showBackButton = false,
  showLogout = false,
  className = ""
}) => {
  const navigate = useNavigate();

  return (
    <header className={`bg-white shadow-md ${className}`}>
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center gap-4">
          {showBackButton && (
            <button
              onClick={() => navigate('/lobby')}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              title="Back to Lobby"
            >
              <ArrowLeft className="w-5 h-5 text-gray-700" />
            </button>
          )}
          
          <img 
            src="/img/logo.png" 
            alt="Vulavula Co-Pilot Logo" 
            className="h-18 lg:h-24 w-auto object-contain cursor-pointer"
            onClick={() => navigate('/')}
          />
        </div>

        {/* Right side actions */}
        <div className="flex items-center gap-4">
          {userName && (
            <div className="hidden sm:block text-right">
              <p className="text-base font-semibold text-gray-900">Hello {userName}</p>
            </div>
          )}
          
          {showLogout && onLogout && (
            <button
              onClick={onLogout}
              className="flex items-center gap-2 px-4 py-2 bg-orange-600 hover:bg-orange-700 text-white font-semibold rounded-lg transition-colors uppercase text-sm"
            >
              <LogOut className="w-4 h-4" />
              <span className="hidden sm:inline">Logout</span>
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;